import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getManagePointsThunk = createAsyncThunk(
    `GetManagePointsSlicer/getManagePointsThunk`,
    async (id, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        const { data } = await focalPointApiClient.get(
            `DistributionAvailableAndHistory/get-distribution-available-by-wallet/${id}`,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetManagePoints: {},
    loadingGetManagePoints: false,
    errorGetManagePoints: false,
};

const GetManagePointsSlicer = createSlice({
    name: 'GetManagePoints',
    initialState,
    reducers: {
        resetDataGetManagePoints: (state) => {
            state.dataGetManagePoints = {};
            state.loadingGetManagePoints = false;
            state.errorGetManagePoints = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getManagePointsThunk.pending, (state) => {
            state.dataGetManagePoints = {};
            state.loadingGetManagePoints = true;
            state.errorGetManagePoints = false;
        });
        builder.addCase(getManagePointsThunk.fulfilled, (state, action) => {
            state.dataGetManagePoints = action.payload;
            state.loadingGetManagePoints = false;
            state.errorGetManagePoints = false;
        });
        builder.addCase(getManagePointsThunk.rejected, (state) => {
            state.dataGetManagePoints = {};
            state.loadingGetManagePoints = false;
            state.errorGetManagePoints = true;
        });
    },
});

export const { resetDataGetManagePoints } = GetManagePointsSlicer.actions;
export default GetManagePointsSlicer.reducer;